<template>
    <div class="setting-main">
        <div class="mask" @click.stop="$emit('hide')">
            <div class="popup_index" @click.stop="" :class="!isPc ? 'mobile' : 'pc'">
                <div class="" :class="!isPc ? '' : 'account_verification'">
                    <div class="popup" :class="!isPc ? 'mobile' : ''">
                        <nav class="nav_mobile_top topPadding" v-if="!isPc">
                            <div class="nav_content">
                                <div class="nav_left">
                                    <div class="back" @click="backTo"><img src="@/assets/img/icon_back.b2094a45.svg"
                                            alt="">
                                    </div>
                                    <div class="logo"><BrandLogo v-show="showSiteBrandLogo" /></div>
                                    <div class="nav_name">VIP</div>
                                </div>
                            </div>
                        </nav>
                        <div class="title" v-if="isPc">{{ $t('loan.loanDetail') }}</div>
                        <div class="step1_content" @click.stop="">
                            <LdSkeleton v-if="loading && !VipInfo" variant="article" />
                            <div v-else v-html="VipInfo"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { customContents } from "@/api/user";
import showSiteBrandLogo from "@/mixins/showSiteBrandLogo";
import BrandLogo from "@/components/BrandLogo.vue";
export default {
    mixins: [showSiteBrandLogo],
    components: { BrandLogo },
    data() {
        return {
            VipInfo: '',
            loading: true
        }
    },

    computed: {
        ...mapState(["isPc"]),
    },

    mounted() {
        this.getVipInfo(localStorage.getItem('lang'))
    },

    methods: {
        backTo() {
            this.$emit('hide')
        },

        getVipInfo(lang = 'en') {
            this.loading = true
            customContents({
                key: 'vipDoc',
                language: lang
            }).then(res => {
                if (res.code == 200) {
                    if (res.result.length == 0 && lang != 'en') {
                        this.getVipInfo('en')
                        return
                    }
                    this.VipInfo = res.result[0].info
                    this.step = 2
                } else {
                    this.$message.error(res.msg)
                }
            }).finally(() => {
                this.loading = false
            })
        },
    },
}
</script>
<style scoped lang="scss">
.show-more {
    margin: 10px auto 0;
}

.collapse-content {
  width: 100%;
  border: 0.01rem solid #000;
  border-radius: 0.2rem;
  padding: 0.16rem 0.2rem;
  box-sizing: border-box;
  margin-bottom: 16px;
}

.collapse-content .info-type-fail {
  color: #ff5858;
}

.collapse-content .info-type-success {
  color: #379000;
}

.collapse-content .content-header {
  cursor: pointer;
  position: relative;
}

.collapse-content .content-header .order-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.collapse-content .content-header .order-top .order-number {
  font-weight: 400;
  font-size: 0.14rem;
  color: rgba(0, 0, 0, 0.5);
}

.collapse-content .content-header .order-top .right-top {
  font-weight: 400;
  font-size: 0.14rem;
  color: #000;
}

.collapse-content .content-header .order-top .right-top .ml-16 {
  margin-left: 0.16rem;
}

.collapse-content .content-header .currency-info {
  margin-top: 0.12rem;
  color: #000;
  display: flex;
  align-items: center;
}

.collapse-content .content-header .currency-info .info-type {
  font-weight: 500;
  font-size: 0.16rem;
  margin-right: 0.2rem;
}

.collapse-content .content-header .currency-info .info-type:last-child {
  margin-right: 0;
}

.collapse-content .content-header .currency-info .info-type.coin-name {
  font-weight: 700;
  font-size: 0.2rem;
}

.collapse-content .content-header .currency-info .info-type-svg .info-type-round {
  width: 100%;
  height: 100%;
  line-height: 100%;
  text-align: center;
  font-size: 0.12rem;
}

.collapse-content .content-header .currency-info .info-number {
  font-weight: 500;
  font-size: 0.16rem;
}

.collapse-content .content-header .result {
  margin-top: 0.12rem;
  margin-bottom: 0.04rem;
}

.collapse-content .content-header .result span {
  font-weight: 400;
  font-size: 0.14rem;
  margin-right: 0.16rem;
  color: #000;
}

.collapse-content .content-header .down-icon {
  position: absolute;
  bottom: -0.04rem;
  right: 0;
}

.collapse-content .content-header .down-icon img {
  width: 0.12rem;
  height: 0.06rem;
}

.collapse-content .content-body {
  border-top: 0.01rem solid rgba(0, 0, 0, 0.2);
  margin-top: 0.22rem;
  padding-top: 0.22rem;
}

.collapse-content .content-body .body-list {
  font-weight: 500;
  font-size: 0.16rem;
  margin-bottom: 0.22rem;
  display: flex;
  justify-content: space-between;
  color: #000;
}

.collapse-content .content-body .body-list .size-18 {
  font-weight: 500;
  font-size: 0.18rem;
}

.collapse-content .content-body .body-list .red-color {
  color: #ff5858;
}

.collapse-content .content-body .body-list .list-right {
  text-align: right;
}

.collapse-content .content-body .close-button {
  width: max-content;
  padding: 0 0.36rem;
  height: 0.5rem;
  background: linear-gradient(180deg, #ffdc61, #ffbc49);
  border-radius: 0.25rem;
  font-weight: 500;
  font-size: 0.18rem;
  color: #000;
  text-align: center;
  line-height: 0.5rem;
  margin-bottom: 0.08rem;
}

.collapse-content .content-body .close-early {
  width: 2.18rem;
}

.collapse-content .content-body .close-Recreate {
  width: 2.58rem;
}

.collapse-content .content-body .order-button {
  width: max-content;
  height: 0.48rem;
  padding: 0 0.7rem;
  border: 0.02rem solid #000;
  border-radius: 0.25rem;
  font-weight: 500;
  font-size: 0.18rem;
  color: #000;
  text-align: center;
  line-height: 0.5rem;
  margin-top: 0.32rem;
}

.collapse-content .content-body .order-button img {
  width: 0.12rem;
  height: 0.06rem;
  vertical-align: middle;
}

.collapse-content .content-body .order-button1 {
  margin-top: 0.1rem;
}

.collapse-content .content-body .body-p {
  font-weight: 300;
  font-size: 0.16rem;
  color: rgba(0, 0, 0, 0.8);
  margin-top: 0.14rem;
  width: 2.9rem;
  line-height: 0.24rem;
}

.collapse-content.mobile {
  padding: 0.2rem 0.22rem;
}

.collapse-content.mobile .content-header .currency-info .info-type {
  margin-right: 0.1rem;
}

.collapse-content.mobile .content-body .close-button {
  background: var(--ld-accent, #5347e0);
  color: var(--ld-accent-text, #fff);
}

.check_ok {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 1px solid #000;
    background-color: #67C23A;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto 0;
}

.loan_sign_box {
    border: 1px solid #000;
    border-radius: .16rem;
    margin-top: .18rem;
    padding: 20px;
    max-height: 70vh;
    overflow: auto;
}

.continue_btn {
    width: 120px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--ld-accent, #5347e0);
    border-radius: 16px;
    font-size: 16px;
    font-weight: 600;
    color: var(--ld-accent-text, #fff);
    margin: 24px auto 0;
    cursor: pointer;
}

.loan_info_content {
    font-size: 21px;
    font-weight: 600;
    text-align: center;
    color: #000000;
    margin: 12px 0 24px;
}

.loan_info_title {
    font-size: 18px;
    text-align: center;
    color: #666666;
}

.loan_info_box {
    // font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    border: 1px solid #000;
    border-radius: .16rem;
    margin-top: .18rem;
    padding: 32px 0;
}

.nav_left {
    width: fit-content;
    justify-content: left !important;
}

.mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    overflow-y: auto;



    .account_verification.mobile {
        width: 100%;
        height: 100%;
        border-radius: 0;
        overflow: auto
    }

}

.account_verification {
    background: #fff;
    border-radius: .18rem
}

.popup {
    padding: .44rem;
    width: 8.62rem;
    box-sizing: border-box
}

.popup .title {
    margin-bottom: .48rem;
    text-align: left;
    font-weight: 700;
    font-size: .34rem;
    color: #000
}

.popup .step1_content {
    margin-bottom: .18rem;
    display: flex;
    flex-wrap: wrap
}

.popup .step1_content .input_item {
    margin-bottom: .22rem;
    width: 3.8rem
}

.popup .step1_content .input_item:nth-child(odd) {
    margin-right: .14rem
}

.popup .step2_content {
    margin-bottom: .4rem;
    display: flex;
    justify-content: space-around
}

.popup .step2_content .phone_item:first-child {
    margin-right: .14rem
}

.popup .step2_content .phone_item:nth-child(2) {
    margin-right: .14rem
}


.popup .step2_content .phone_item .item_title {
    padding: 0 .4rem;
    margin-bottom: .22rem;
    font-weight: 500;
    font-size: .16rem;
    color: #000;
    text-align: center;
}

.popup .step2_content .phone_item .item_upload {
    padding: .24rem 0;
    border: .01rem dashed #000;
    border-radius: .2rem;
    text-align: center
}

.popup .step2_content .phone_item .item_upload .file_input {
    display: none
}

.popup .step2_content .phone_item .item_upload .upload_tips {
    color: #000
}

.popup .step2_content .phone_item .item_upload .upload_tips .main_tip {
    font-size: .16rem
}

.popup .step2_content .phone_item .item_upload .upload_tips .main_tip span {
    cursor: pointer;
    color: #4d4fff
}

.popup .step2_content .phone_item .item_upload .upload_tips .sub_tip {
    margin-top: .1rem;
    color: rgba(0, 0, 0, .5);
    font-size: .14rem
}

.popup .step2_content .phone_item .item_upload_resilt {
    width: .72rem;
    height: .72rem
}

.popup .step3_content {
    margin-bottom: .4rem;
    padding: .24rem .44rem .36rem .44rem;
    border: .01rem solid #000;
    border-radius: .2rem;
    display: flex;
    flex-direction: column;
    align-items: center
}

.popup .step3_content .item_upload_resilt {
    width: 3.78rem;
    height: 1.72rem
}

.popup .step3_content .file_input {
    display: none
}

.popup .step3_content .idcard_content {
    margin-bottom: .18rem;
    width: 1.26rem;
    height: 1.26rem;
    background: #000;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center
}

.popup .step3_content .idcard_content img {
    width: .6rem;
    height: .6rem
}

.popup .step3_content .idcard_img {
    margin-bottom: .18rem;
    width: 1.26rem;
    height: 1.26rem
}

.popup .step3_content .tips {
    margin-bottom: .18rem;
    padding: 0 .8rem;
    font-weight: 400;
    font-size: .18rem
}

.popup .step3_content .tips span {
    cursor: pointer;
    color: #4d4fff;
    white-space: nowrap
}

.popup .step4_content {
    margin-bottom: .4rem
}

.popup .step4_content .status_title {
    font-weight: 500;
    font-size: .24rem;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center
}

.popup .step4_content .status_title .status_icon {
    margin-left: .08rem;
    width: .26rem;
    height: .26rem;
    border-radius: 50%;
    background: #00c308;
    display: flex;
    justify-content: center;
    align-items: center
}

.popup .step4_content .status_title .status_icon img {
    width: .14rem;
    height: auto
}

.popup .step4_content .status_content {
    margin-top: .16rem;
    font-size: .18rem;
    text-align: center;
    color: rgba(0, 0, 0, .6)
}

.popup .submit_content {
    display: flex
}

.popup .submit_content .submit_btn {
    height: .42rem
}

.popup.step3 {
    width: 6.54rem
}


.popup.mobile {
    padding: 0 .24rem;
    padding-top: 1.02rem;
    padding-bottom: .4rem;
    width: 100%;
}

.popup.mobile .step1_content .input_item {
    width: 100%
}

.popup.mobile .step1_content .input_item:nth-child(odd) {
    margin-right: 0
}

.popup.mobile .step2_content {
    flex-direction: column
}

.popup.mobile .step2_content .phone_item {
    width: 100%
}

.popup.mobile .step2_content .phone_item:first-child {
    margin-right: 0;
    margin-bottom: .5rem
}

.popup.mobile .step2_content .phone_item:nth-child(2) {
    margin-right: 0;
    margin-bottom: .5rem
}

.popup.mobile .step2_content .phone_item .item_title {
    padding: 0 .2rem
}

.popup.mobile .step3_content {
    margin-bottom: .24rem;
    padding: .24rem
}

.popup.mobile .step3_content .actions .action_btn {
    height: .48rem
}

.popup.mobile .step3_content .actions .action_btn:first-child {
    margin-bottom: .16rem
}

.popup.mobile .step4_content {
    margin-bottom: .24rem;
    padding: .24rem;
    border: .01rem solid #000;
    border-radius: .2rem
}

.popup.mobile .step4_content .status_title {
    font-weight: 500;
    font-size: .24rem;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center
}

.popup.mobile .step4_content .status_title .status_icon {
    margin-left: .08rem;
    width: .26rem;
    height: .26rem;
    border-radius: 50%;
    background: #00c308;
    display: flex;
    justify-content: center;
    align-items: center
}

.popup.mobile .step4_content .status_title .status_icon img {
    width: .14rem;
    height: auto
}

.popup.mobile .step4_content .status_content {
    margin-top: .16rem;
    font-size: .18rem;
    text-align: center;
    color: rgba(0, 0, 0, .6)
}

.popup.mobile .submit_content {
    display: flex;
    justify-content: center
}

.popup.mobile .submit_content .submit_btn {
    height: .68rem
}




.input_fields {
    position: relative;
    width: 100%;
    height: .68rem;
    box-sizing: border-box;
    border: .02rem solid rgba(0, 0, 0, .2);
    border-radius: .2rem
}

.input_fields .input {
    width: 100%;
    height: 100%;
    border-radius: .2rem;
    box-sizing: border-box;
    padding: 0 .28rem;
    border: unset;
    outline: none;
    color: #000;
    font-weight: 500;
    caret-color: #000
}

.input_fields .input::placeholder {
    color: rgba(0, 0, 0, .5)
}

.input_fields .input:disabled {
    color: rgba(0, 0, 0, .5)
}

.input_fields .label_name {
    padding: 0 .06rem;
    position: absolute;
    top: -.15rem;
    left: .26rem;
    font-weight: 500;
    font-size: .18rem;
    color: rgba(0, 0, 0, .5);
    background: #fff
}

.input_fields.active {
    border: .02rem solid var(--ld-accent, #5347e0);
    box-shadow: 0 0 0 3px var(--ld-accent-muted, #eef0ff);
}

.input_fields.active .label_name {
    color: var(--ld-accent, #5347e0);
}

.input_select {
    position: relative;
    width: 100%;
    height: .68rem;
    box-sizing: border-box;
    border: .02rem solid rgba(0, 0, 0, .2);
    border-radius: .2rem
}

.input_select .input_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: .2rem;
    height: 100%;
    padding-right: .26rem
}

.input_select .input_content .input {
    flex: 1;
    height: 100%;
    border-radius: .2rem;
    padding: 0 .28rem;
    color: #000;
    font-weight: 500;
    caret-color: #000
}

.input_select .input_content .input::placeholder {
    color: rgba(0, 0, 0, .5)
}

.input_select .input_content img {
    width: .12rem;
    height: auto
}

.input_select .label_name {
    padding: 0 .06rem;
    position: absolute;
    top: -.15rem;
    left: .26rem;
    font-weight: 500;
    font-size: .18rem;
    color: rgba(0, 0, 0, .5);
    background: #fff
}

.input_select .select {
    position: absolute;
    left: 0;
    width: 100%;
    max-height: 3.2rem;
    box-sizing: border-box;
    background: #fff;
    border: 0.01rem solid rgba(0, 0, 0, .2);
    border-radius: 0.1rem;
    z-index: 99;
    overflow: auto;
    bottom: 0.84rem !important;
}

.input_select .select .option {
    cursor: pointer;
    padding: 0 .28rem;
    height: .48rem;
    line-height: .48rem;
    text-align: left
}

.input_select .select .option:hover {
    background: rgba(0, 0, 0, .1)
}

.input_select.active {
    border: .02rem solid #000
}

.input_select.active .label_name {
    color: #000
}

.input_select {
    position: relative;
    width: 100%;
    height: .68rem;
    box-sizing: border-box;
    border: .02rem solid rgba(0, 0, 0, .2);
    border-radius: .2rem
}

.input_select .input_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: .2rem;
    height: 100%;
    padding: 0 .28rem
}

.input_select .input_content .code {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: .18rem;
    color: #000
}

.input_select .input_content .code span {
    padding-bottom: .04rem
}

.input_select .input_content .code img {
    margin-left: .08rem;
    width: .08rem;
    height: auto
}

.input_select .input_content .divider {
    margin-left: .14rem;
    margin-right: .18rem;
    width: 0;
    height: .18rem;
    border: .01rem solid rgba(0, 0, 0, .2)
}

.input_select .input_content .input {
    flex: 1;
    height: 100%;
    border-radius: .2rem;
    color: #000;
    font-weight: 500;
    caret-color: #000
}

.input_select .input_content .input::placeholder {
    color: rgba(0, 0, 0, .5)
}

.input_select .label_name {
    padding: 0 .06rem;
    position: absolute;
    top: -.15rem;
    left: .26rem;
    font-weight: 500;
    font-size: .18rem;
    color: rgba(0, 0, 0, .5);
    background: #fff
}

.input_select .select {
    position: absolute;
    bottom: .76rem;
    left: 0;
    width: 100%;
    max-height: 3.2rem;
    box-sizing: border-box;
    background: #fff;
    border: .01rem solid rgba(0, 0, 0, .2);
    border-radius: .1rem;
    z-index: 99;
    overflow: auto
}

.input_select .select .option {
    cursor: pointer;
    padding: 0 .28rem;
    height: .48rem;
    line-height: .48rem;
    text-align: left
}

.input_select .select .option:hover {
    background: rgba(0, 0, 0, .1)
}

.input_select.active {
    border: .02rem solid #000
}

.input_select.active .label_name {
    color: #000
}

.input_fields {
    position: relative;
    width: 100%;
    height: .68rem;
    box-sizing: border-box;
    border: .02rem solid rgba(0, 0, 0, .2);
    border-radius: .2rem
}

.input_fields .el-input {
    width: 100%;
    height: 100%;
    border-radius: .2rem;
    box-sizing: border-box;
    border: unset;
    outline: none;
    color: #000;
    font-weight: 500;
    caret-color: #000;

}

.input_fields ::v-deep .el-input__wrapper {
    box-shadow: none;
    background: none;
    border: none !important;
    height: 0.68rem;

    .el-icon svg {
        height: 1em !important;
        width: 1em !important;
    }
}

.input_fields ::v-deep .el-input__inner {
    border: none !important;
    background: none;
    line-height: 0.6rem;
    color: #000;
    margin-top: 10px;
    font-size: 18px;
}


.input_fields .el-input::placeholder {
    color: rgba(0, 0, 0, .5)
}

.input_fields .el-input .el-input__wrapper .el-input__inner {
    color: #000
}

.input_fields .el-input .el-input__wrapper:hover {
    box-shadow: none;
    background: none
}

.input_fields .label_name {
    padding: 0 .06rem;
    position: absolute;
    top: -.15rem;
    left: .26rem;
    font-weight: 500;
    font-size: .18rem;
    color: rgba(0, 0, 0, .5);
    background: #fff
}

.input_fields.active {
    border: .02rem solid var(--ld-accent, #5347e0);
    box-shadow: 0 0 0 3px var(--ld-accent-muted, #eef0ff);
}

.input_fields.active .label_name {
    color: var(--ld-accent, #5347e0);
}

.box[data-v-2a86ad2b] {
    width: 5rem;
    height: 4rem;
    margin: auto
}

.sex .select {
    position: absolute;
    top: 0.68rem;
    left: 0;
    width: 100%;
    max-height: 2.4rem;
    box-sizing: border-box;
    background: #fff;
    border: 0.01rem solid rgba(0, 0, 0, .2);
    border-radius: 0.1rem;
    z-index: 99;
    overflow: auto;
    height: 1rem;
}

.card .select {
    height: 1.5rem;
}

// .popup.mobile {
//     padding: 0 0.24rem;
//     padding-top: 3rem;
//     padding-bottom: 0.4rem;
//     width: 100%;
// }
.popup_index {
    background: #fff;
    border-radius: .18rem
}

.popup_index.mobile {
    width: 100%;
    height: 100%;
    border-radius: 0;
    overflow: auto
}
</style>